// extracted by mini-css-extract-plugin
module.exports = {"banner":"index_banner__duL4l","content":"index_content__xYyWm","title":"index_title__1iGVm","text":"index_text__Oej7h","btns":"index_btns__BuXRi"};